import * as z from "zod";

export const getSupportTopicVolumes = {
  name: "getSupportTopicVolumes" as const,
  input: z.null(),
  output: z.object({
    ticketCount: z.number(),
    topics: z.array(z.object({ topic: z.string(), count: z.number() })),
  }),
};
